import React, { useState, useEffect } from 'react';
import ImagesAll from '../assets';
import Carousel from 'react-bootstrap/Carousel';

const VenueContact = ({isEventLive, coordinatorList}) => {
  const committeeEmail = "cab@encora.com";
  const [coordinators, setCoordinators] = useState([
    /* {
      coordinatorId: "0",
      eventId: "0",
      userId: "0",
      organizingCommitteeEmail: committeeEmail,
      firstName: "Jessica",
      lastName: "Gamboa",
      emailId: "Jessica.Gamboa@encora.com",
      designation: "Event Coordinator",
      linkedInProfileURL: "",
      profilePhotoPath: ImagesAll.Members.JessicaGamboa,
      coordinatorContactNumber: "+506 8891 9787",
      default: true
    } */
  ]);
  const [currentCoordinatorIndex, setCurrentCoordinatorIndex] = useState(0);

  useEffect(()=>{
    (coordinatorList.length > 0) && setCoordinators(coordinatorList);
  }, [coordinatorList]);

  const nextCoordinator = () => {
    setCurrentCoordinatorIndex((prevIndex) => (prevIndex + 1) % coordinators.length);
  };

  const prevCoordinator = () => {
    setCurrentCoordinatorIndex((prevIndex) => {
      const newIndex = prevIndex - 1;
      return newIndex < 0 ? coordinators.length - 1 : newIndex;
    });
  };

  return (
    <div className="venue-contact">
      <div className="d-flex">
        { isEventLive &&
          <div className='venue-details w3-card-2 w3-margin-bottom w3-round w3-white w3-padding w3-padding-16 p-0 p-md-3'>
            {/* Venue Section */}
            <h4 className='roboto-bold'>VENUE</h4>
            <p className='roboto-bold color-black'>The Ritz-Carlton, Half Moon Bay</p>
            <p>With stunning Pacific Ocean Views, The Ritz-carlton, Half Moon Bay, offers a luxurious experience just 20 miles from San Francisco International Airport. This Forbes Five-Star resort is renowned for its breathtaking views, exceptional service, and unique local touches.</p>

            <div className='image-container w3-margin-top w3-margin-bottom'>
              <div>
                <a target="_blank" className="venue-image" href='https://www.ritzcarlton.com/en/hotels/hafrz-the-ritz-carlton-half-moon-bay/overview/'>
                  <img className='w3-round-large' src={ImagesAll.OtherImages.Venue} alt="Event Location" style={{ width: '100%' }} />
                </a>
              </div>
              <div>
                <a target="_blank" className="map-image" href='https://maps.app.goo.gl/VKpsNPc8zTL8w4MW6'>
                  <img className='w3-round-large' src={ImagesAll.OtherImages.Map} alt="Event Location" style={{ width: '100%' }} />
                </a>
                <a target="_blank" className='google-map-link color-blue' href='https://maps.app.goo.gl/VKpsNPc8zTL8w4MW6'>View Map</a>
              </div>
            </div>
          </div>
        }
        <div id='contact-info-section' className='contact-details w3-card-2 w3-margin-bottom-2em w3-round w3-white w3-padding w3-padding-16'>
          {/* contact info Section */}
          <div className='p-0 p-md-3'>
            <h4 className='roboto-bold'>CONTACT INFO</h4>
            <div className='row'>
              <div className='col-12 col-md-6 mb-3 pe-md-2 d-flex'>
                <div className="event-org w3-panel bg-blue border-bottom w3-round d-flex flex-dir-col  justify-content-center p-4 cOrgCommittee w-100">
                  
                    <div className='d-flex comp-logo-name align-items-center mb-4 ms-0 ms-md-3'>
                      <div className=''></div>
                      {/* <img className='w3-half' src={ImagesAll.Logos.EncoraBlack} alt="Event Location" />
                      <span className='roboto-bold name-of-site'>Customer<br></br> Advisory Board</span> */}
                    </div>

                    <div className='d-flex org-committee m-0 ms-md-3'>
                      <h5 className='color-black roboto-medium m-0 mb-2'>Organizing Committee</h5>
                      <p className='color-purple t-d m-0'>{committeeEmail}</p>
                    </div>           
                </div>
              </div>

              <div className='col-12 col-md-6 ps-md-2 d-flex mb-md-3'>
                <div className="event-coordinator d-flex w3-panel bg-blue border-bottom w3-round pt-4 pb-4 p-0 ps-md-4 pe-md-4 w-100">
                  <button type='button' className='cBtn-prev-next icons icon-caret-left' onClick={prevCoordinator} disabled= {currentCoordinatorIndex === 0}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-chevron-left" viewBox="0 0 16 16">
                      <path d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"/>
                    </svg>
                  </button>
                    <Carousel className='w-100' activeIndex={currentCoordinatorIndex} slide={true} controls={false} indicators={false} interval={null} >
                      {coordinators.length > 0 && coordinators.map((coordinator, index) => (
                        <Carousel.Item key={index}>
                          <div className="d-flex justify-content-center align-items-center">
                            <div className='cCoordinator d-flex justify-content-center align-items-center'> 
                              <div className='d-flex align-items-center me-2 me-md-4'>
                                {(coordinator.profilePhotoPath === null || coordinator.profilePhotoPath === "") ? ( 
                                  <img src={ImagesAll.Members.NoImg} alt={coordinator.firstName+' '+coordinator.lastName} className="w3-circle"/>
                                ) : (
                                  <img src={coordinator.default ? coordinator.profilePhotoPath : process.env.REACT_APP_API_URL+'/'+coordinator.profilePhotoPath} alt={coordinator.firstName+' '+coordinator.lastName} className="w3-circle"/>
                                )}
                              </div>

                              <div className='d-flex user-contact'>
                                <h5 className='color-black roboto-medium m-0'>{coordinator.firstName+' '+coordinator.lastName}</h5>
                                <p className='roboto-medium mt-1'>{coordinator.designation}</p>
                                <p className='m-0 mb-1'>
                                  <a href={`mailto:${coordinator.emailId}`} className="color-purple text-break">
                                      {coordinator.emailId}
                                    </a>
                                </p>
                                <p className='roboto-medium color-blue m-0 d-flex align-items-center' style={{height: '22px'}}>
                                  {coordinator.linkedInProfileURL &&
                                    <a className='me-2' href={coordinator.linkedInProfileURL} target="_blank">
                                    <span className="icon-linkedin">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-linkedin" viewBox="0 0 16 16">
                                        <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z"/>
                                      </svg>
                                    </span>
                                    </a>
                                  }
                                  <span className='color-black'>{coordinator.coordinatorContactNumber}</span>
                                </p>
                              </div>
                            </div>                            
                          </div>
                        </Carousel.Item>
                      ))}
                    </Carousel>
                  <button type='button' className='cBtn-prev-next icons icon-caret-right' onClick={nextCoordinator} disabled={currentCoordinatorIndex === coordinators.length - 1}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" className="bi bi-chevron-right" viewBox="0 0 16 16">
                      <path d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VenueContact;
